import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=a55571ee&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a55571ee')) {
      api.createRecord('a55571ee', component.options)
    } else {
      api.reload('a55571ee', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=a55571ee&", function () {
      api.rerender('a55571ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fSorv4GTLcBg/JS/comp/ImgFallback2.vue"
export default component.exports